import {
  BetMarketIcon,
  FootballIcon,
  JockerIcon,
  KenoIcon,
  LiveCasinoIcon,
  LiveIcon,
  PockerIcon,
  SlotsIcon,
  SlotTournamentIcon,
  SpinGamesIcon, SportTournamentsIcon,
  TableGamesIcon,
  VirtualGamesIcon,
  VoltIcon,
  JetXIcon2
} from '../../assets/icons/menu';

export let NavConfig = [
  { label: 'სპორტი', url: '/sport', icon: FootballIcon },
  { label: 'LIVE', url: '/live', icon: LiveIcon },
  { label: 'სპორტის ტურნირები', url: '/page/sport-tournament', icon: SportTournamentsIcon },
  { label: 'ვირტუალური სპორტი', url: '/vSport', icon: VirtualGamesIcon },
  {
    label: 'პოკერი',
    url: '/poker',
    icon: PockerIcon,
    children: [
      { label: 'სპინ პოკერი', url: '/play/leaderPoker?tt=2' },
      { label: 'ლიდერ პოკერი', url: '/play/leaderPoker?tt=0' },
    ],
  },
  { label: 'სლოტები', url: '/slots', icon: SlotsIcon, badge: 'new' },
  { label: 'ბეთმარკეტი', url: '/page/betmarket', icon: BetMarketIcon, badge: 'new' },
  {
    label: 'მაგიდის თამაშები',
    url: '/games',
    icon: TableGamesIcon,
    children: [
      { label: 'ბურა', url: '/play/bura' },
      { label: 'დომინო', url: '/play/domino' },
      { label: 'ნარდი', url: '/play/nardi' },
    ],
  },
  {
    label: 'სპინ თამაშები',
    url: '/spin-games',
    icon: SpinGamesIcon,
    children: [
      { label: 'სპინ ბურა', url: '/play/bura?target=spin' },
      { label: 'სპინ დომინო', url: '/play/domino?target=spin' },
      { label: 'სპინ ნარდი', url: '/play/nardi?target=spin' },
      { label: 'სპინ პოკერი', url: '/play/leaderPoker?tt=2' },
    ],
  },
  { label: 'კენო', url: '/play/keno', icon: KenoIcon },
  { label: 'ჯოკერი', url: '/play/joker', icon: JockerIcon },
  {
    label: 'სლოტის ტურნირები',
    url: '/page/slots-tournaments',
    icon: SlotTournamentIcon,
  },
  { label: 'LIVE კაზინო', url: '/live-casino', icon: LiveCasinoIcon },
  { label: 'ვოლტი', url: '/play/volt', icon: VoltIcon },
  { label: 'JetX', url: '/play/jetX', icon: JetXIcon2, badge: 'new' }
];
